export class MediaFileInfo {
  url: string;
  filename: string;
  contentType: string;
}
